(() => {
  const madridClock = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit'});
  const dateLabel = new Intl.DateTimeFormat('es-ES', {timeZone:'UTC',weekday:'long',day:'numeric',month:'long'});
  const nextDay = date => date.setUTCDate(date.getUTCDate()+1);
  function goodFriday(year) {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3);
    const h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    const value=h+l-7*m+114;
    return new Date(Date.UTC(year,Math.floor(value/31)-1,(value%31)+1-2));
  }
  function nationalHoliday(date) {
    const key=String(date.getUTCMonth()+1).padStart(2,'0')+'-'+String(date.getUTCDate()).padStart(2,'0');
    return ['01-01','01-06','05-01','08-15','10-12','11-01','12-06','12-08','12-25'].includes(key) || date.getTime()===goodFriday(date.getUTCFullYear()).getTime();
  }
  const workday = date => date.getUTCDay()!==0 && date.getUTCDay()!==6 && !nationalHoliday(date);
  function addWorkdays(base,days) {
    const date=new Date(base);
    while(days>0){nextDay(date);if(workday(date))days--;}
    return date;
  }
  function windowFor(now,min,max) {
    const values=Object.fromEntries(madridClock.formatToParts(now).map(p=>[p.type,p.value]));
    const base=new Date(Date.UTC(Number(values.year),Number(values.month)-1,Number(values.day)));
    return {start:addWorkdays(base,min),end:addWorkdays(base,max),base};
  }
  function label(date, includeMonth = true) {
    const parts = Object.fromEntries(dateLabel.formatToParts(date).map(p => [p.type,p.value]));
    return parts.weekday + ' ' + parts.day + (includeMonth ? ' de ' + parts.month : '');
  }
  function dateFragments(start, end) {
    const sameMonth = start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth();
    return [label(start, !sameMonth), label(end)];
  }
  function renderDates(output, template, start, end) {
    const labels = dateFragments(start, end);
    const text = template.replace('{start}', labels[0]).replace('{end}', labels[1]).replace(/\.?$/, '.');
    if (output.textContent === text && output.querySelectorAll('strong').length === 2) return;
    const pieces = template.replace(/\.?$/, '.').split(/(\{start\}|\{end\})/);
    output.replaceChildren(...pieces.map(piece => {
      if (piece !== '{start}' && piece !== '{end}') return document.createTextNode(piece);
      const strong = document.createElement('strong');
      strong.textContent = labels[piece === '{start}' ? 0 : 1];
      return strong;
    }));
  }
  class DeliveryWindow extends HTMLElement {
    connectedCallback() {
      if(this.timer)return;
      this.update=()=>{
        const min=Number(this.dataset.min),max=Number(this.dataset.max),output=this.querySelector('[data-delivery-dates]');
        if(!output||!Number.isInteger(min)||!Number.isInteger(max)||min<1||max<min||max>365)return;
        const dates=windowFor(new Date(),min,max);
        renderDates(output, this.dataset.between, dates.start, dates.end);
        this.dataset.earliest=dates.start.toISOString().slice(0,10);this.dataset.latest=dates.end.toISOString().slice(0,10);
      };
      this.update();this.timer=setInterval(this.update,30000);
      document.addEventListener('visibilitychange',this.update);window.addEventListener('pageshow',this.update);
    }
    disconnectedCallback(){clearInterval(this.timer);this.timer=null;document.removeEventListener('visibilitychange',this.update);window.removeEventListener('pageshow',this.update);}
  }
  if(!customElements.get('astro-delivery-window'))customElements.define('astro-delivery-window',DeliveryWindow);
})();
